import { Authenticated, ErrorComponent } from "@refinedev/core";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { CreateStore } from "../pages/stores/create-store/CreateStore";
import { Login } from "../pages/authentication/Login";
import { SyncrosaleLayout } from "../components/layout/SyncrosaleLayout";
import { StoreSettings } from "../pages/stores/store-settings/StoreSettings";
import { Filters } from "../pages/store-security/filters/Filters";
import { PricingSettings } from "../pages/stores/pricing-settings/PricingSettings";
import { Inventory } from "../pages/inventory/inventory/Inventory";
import { Restrictions } from "../pages/store-security/restrictions/Restrictions";
import { Extension } from "../pages/extension/Extension";
import { Product } from "../pages/product/Product";
import { CompetitionSettings } from "../pages/stores/competition-settings/CompetitionSettings";
import { Orders } from "../pages/orders/Orders";
import { OrderDetails } from "../pages/order-details/OrderDetails";
import { MailNotificationSettings } from "../pages/stores/mail-notification-settings/MailNotificationSettings";
import { ServiceSelection } from "../pages/warehouse/ServiceSelection";
import { Maintenance } from "../pages/maintenance/Maintenance";

const SyncrosaleRouter = () => {
  return (
    <Routes>
      <Route
        element={
          <Authenticated
            key="authenticated-inner"
            fallback={<Navigate to="/login" replace={true} />}
          >
            <SyncrosaleLayout>
              <Outlet />
            </SyncrosaleLayout>
          </Authenticated>
        }
      >
        <Route index element={<Orders />} />
        <Route path="order-detail/:orderId" element={<OrderDetails />} />
        <Route path="inventory">
          <Route path="" element={<Inventory />} />
          <Route path="product/:asin" element={<Product />} />
        </Route>

        <Route path="store">
          <Route path="create" element={<CreateStore />} />
          <Route path="store-settings" element={<StoreSettings />} />
          <Route path="pricing-settings" element={<PricingSettings />} />
          <Route
            path="mail-notification"
            element={<MailNotificationSettings />}
          />

          <Route
            path="competition-settings"
            element={<CompetitionSettings />}
          />
        </Route>

        <Route path="store-security">
          <Route path="restrictions" element={<Restrictions />} />
          <Route path="filters" element={<Filters />} />
          <Route path="*" element={<ErrorComponent />} />
        </Route>

        <Route path="extension" element={<Extension />} />
        <Route path="warehouse" element={<ServiceSelection />} />
      </Route>
      <Route path="/maintenance" element={<Maintenance />} />
      <Route
        element={
          <Authenticated key="authenticated-outer" fallback={<Outlet />}>
            <Navigate to="/" replace={true} />
          </Authenticated>
        }
      >
        <Route path="/login" element={<Login />} />
      </Route>
    </Routes>
  );
};

export default SyncrosaleRouter;
